// extracted by mini-css-extract-plugin
export default {"container":"form-button_container__3_-fX","loading":"form-button_loading__14qXb","loadingIcon":"form-button_loadingIcon__3pW3b"};